export default {
  install(Vue) {
    Vue.prototype.$intervals = [];
    Vue.prototype.$setInterval = (func, intervalMilliSec) => {
      const id = setInterval(() => {
        func();
      }, intervalMilliSec);
      Vue.prototype.$intervals.push(id);
      return id;
    };
    Vue.prototype.$clearInterval = id => {
      Vue.prototype.$intervals.forEach(clearInterval);
      Vue.prototype.$intervals = Vue.prototype.$intervals.filter(v => {
        return v !== id;
      });
    };
    Vue.prototype.$clearAllIntervals = () => {
      Vue.prototype.$intervals.forEach(clearInterval);
      Vue.prototype.$intervals = [];
    };
  }
};
